import dayjs from 'dayjs';

import { DateHelpers } from '@shared/helpers';

export function normalizeDate(raw: string, minDate: Date, maxDate: Date): string {
    const {getDateYear} = DateHelpers;
    const parts = raw.split('.');
    let [dd, mm, yyyy] = [parts[0] || '', parts[1] || '', parts[2] || ''];

    if (yyyy.length === 4) {
        const y = +yyyy;
        const minY = getDateYear(minDate);
        const maxY = getDateYear(maxDate);
        yyyy = String(Math.max(minY, Math.min(maxY, y)));
    }

    if (mm.length === 2) {
        let m = +mm;
        m = Math.max(1, Math.min(12, m));
        if (yyyy.length === 4) {
            const dt = dayjs(`${yyyy}-${String(m).padStart(2, '0')}-01`);
            if (dt.isBefore(dayjs(minDate), 'month')) m = dayjs(minDate).month() + 1;
            if (dt.isAfter(dayjs(maxDate), 'month')) m = dayjs(maxDate).month() + 1;
        }
        mm = String(m).padStart(2, '0');
    }

    if (dd.length === 2) {
        let d = +dd;
        const maxDay =
            mm.length === 2 && yyyy.length === 4
                ? dayjs(`${yyyy}-${mm}`, 'YYYY-MM').daysInMonth()
                : 31;
        d = Math.max(1, Math.min(maxDay, d));
        if (mm.length === 2 && yyyy.length === 4) {
            const dt = dayjs(`${yyyy}-${mm}-${String(d).padStart(2, '0')}`, 'YYYY-MM-DD');
            if (dt.isBefore(dayjs(minDate))) {
                const md = dayjs(minDate);
                d = md.date();
                mm = String(md.month() + 1).padStart(2, '0');
                yyyy = String(md.year());
            } else if (dt.isAfter(dayjs(maxDate))) {
                const md = dayjs(maxDate);
                d = md.date();
                mm = String(md.month() + 1).padStart(2, '0');
                yyyy = String(md.year());
            }
        }
        dd = String(d).padStart(2, '0');
    }

    if (dd && mm && yyyy) return `${dd}.${mm}.${yyyy}`;
    return [dd, mm, yyyy].filter(Boolean).join('.');
}
